import { useState } from "react";
import { Button } from "../ui/button.tsx";
import { Input } from "../ui/input.tsx";
import { Select } from "../ui/select.tsx";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card.tsx";
import { Badge } from "../ui/badge.tsx";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table.tsx";


export const TeamList = ({teams, generateRounds, clearTeamPoints, clearPlayerPoints, clearRounds, clearTeams}) =>{
    const [func, setFunc] = useState(() => {});
    return(
        <Card>
        <CardHeader>
          <CardTitle>Tournament Teams</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Team</TableHead>
                  <TableHead>Players</TableHead>
                  <TableHead>Points</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {teams.map((team, index) => (

                  <TableRow key={index}>
                    <TableCell className="font-medium">{team.name}</TableCell>
                    <TableCell>{team.players.length}</TableCell>
                    <TableCell>{team.points}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            
            <Button onClick={generateRounds} className="w-full">
              Generate Rounds
            </Button>

            <div className="flex justify-between ">
                <Button onClick={() => setFunc(() => clearTeamPoints)} className="w-half" variant="destructive" command="show-modal" commandfor="dialog">
                  Clear Team Points
                </Button>
                <Button onClick={() => setFunc(() => clearPlayerPoints)} className="w-half" variant="destructive"  command="show-modal" commandfor="dialog">
                  Clear Player Points
                </Button>
            </div>

            <div className="flex justify-between ">
                <Button onClick={() => setFunc(() => clearRounds)} className="w-half" variant="destructive" command="show-modal" commandfor="dialog">
                  Clear Rounds
                </Button>
                <Button onClick={() => setFunc(() => clearTeams)} className="w-half" variant="destructive" command="show-modal" commandfor="dialog">
                  Clear Teams
                </Button>
            </div>
          </div>
        </CardContent>





       <el-dialog>
          <dialog id="dialog" aria-labelledby="dialog-title" class="fixed inset-0 size-auto max-h-none max-w-none overflow-y-auto bg-transparent backdrop:bg-transparent">
            <el-dialog-backdrop class="fixed inset-0 bg-gray-900/50 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"></el-dialog-backdrop>

            <div tabindex="0" class="flex min-h-full items-end justify-center p-4 text-center focus:outline-none sm:items-center sm:p-0">
              <el-dialog-panel class="relative transform overflow-hidden rounded-lg bg-gray-800 text-left shadow-xl outline -outline-offset-1 outline-white/10 transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full sm:max-w-lg data-closed:sm:translate-y-0 data-closed:sm:scale-95">
                <div class="bg-gray-800 px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div class="sm:flex sm:items-start">
                    <div class="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-500/10 sm:mx-0 sm:size-10">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" data-slot="icon" aria-hidden="true" class="size-6 text-red-400">
                        <path d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>
                    <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                      <h3 id="dialog-title" class="text-base font-semibold text-white">DANGEROUS ACTION!!!!</h3>
                      <div class="mt-2">
                        <p class="text-sm text-gray-400">Are you sure you want to do this???</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bg-gray-700/25 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button type="button" command="close" onClick={func} commandfor="dialog" class="inline-flex w-full justify-center rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white hover:bg-red-400 sm:ml-3 sm:w-auto">DO IT</button>
                  <button type="button" command="close" commandfor="dialog" class="mt-3 inline-flex w-full justify-center rounded-md bg-white/10 px-3 py-2 text-sm font-semibold text-white inset-ring inset-ring-white/5 hover:bg-white/20 sm:mt-0 sm:w-auto">NO</button>
                </div>
              </el-dialog-panel>
            </div>
          </dialog>
        </el-dialog>
      </Card>

      
    )
}